import { useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import {
  AUTOKEY_GA_CLIENT_ID,
  AUTOKEY_GA_SESSION_ID,
  getItemLocalStorage,
  setItemLocalStorage,
} from '../utils/helper';

const AnalyticsInitializer = ({ analyticsKey }) => {
  useEffect(() => {
    if (!analyticsKey) {
      console.warn('Google Analytics Key is not provided.');
      return;
    }

    let clientId = getItemLocalStorage(AUTOKEY_GA_CLIENT_ID);
    if (!clientId) clientId = uuidV4();
    setItemLocalStorage(AUTOKEY_GA_CLIENT_ID, clientId);

    let sessionId = sessionStorage.getItem(AUTOKEY_GA_SESSION_ID);
    if (!sessionId) sessionId = uuidV4();
    sessionStorage.setItem(AUTOKEY_GA_SESSION_ID, sessionId);

    if (!window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsKey}`;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = window.gtag || gtag;

        window.gtag('js', new Date());

        window.gtag('config', analyticsKey, {
          client_storage: 'none',
          client_id: clientId,
          user_id: sessionId,
        });
      };

      script.onerror = () => {
        console.error('Failed to load Google Analytics script.');
      };

      return () => {
        document.head.removeChild(script);
        delete window.gtag;
        delete window.dataLayer;
      };
    } else {
      window.gtag('config', analyticsKey, {
        client_storage: 'none',
        client_id: clientId,
        user_id: sessionId,
      });
    }
  }, [analyticsKey]);
};

export default AnalyticsInitializer;
